import {
  clearStorageInfoKeys,
  invalidatePersistedSession,
} from './session-cache';

export const DB_NAME = 'OrderManager';
// LocalForage normalizza i caratteri non alfanumerici del nome in underscore. Usiamo direttamente
// il nome fisico per evitare che cerchi uno store diverso e incrementi autonomamente la versione.
export const DB_STORE_NAME = 'order_manager_storage';
const OBSOLETE_DB_STORE_NAMES = ['order-manager_storage'];
const LOCAL_FORAGE_BLOB_STORE_NAME = 'local-forage-detect-blob-support';
export const DB_VERSION = 23;

/**
 * Barriera iniziale condivisa da auth e persistenza IDB. Nessuno snapshot deve essere letto prima
 * che l'eventuale upgrade abbia eliminato cache e sessione, altrimenti il vecchio authStore potrebbe
 * essere gia' in memoria quando onupgradeneeded lo rimuove da localStorage.
 */
export const databaseVersionReady = new Promise<void>((resolve) => {
  const openRequest = indexedDB.open(DB_NAME, DB_VERSION);

  openRequest.onsuccess = () => {
    const db = openRequest.result;
    db.onversionchange = (event) => {
      if (event.newVersion !== event.oldVersion) {
        console.log('[LOCALFORAGE] version changed in another tab', event.oldVersion, event.newVersion);
        db.close();
        window.location.reload();
      }
    };
    resolve();
  };

  openRequest.onupgradeneeded = (event: IDBVersionChangeEvent) => {
    const db = openRequest.result;
    const transaction = openRequest.transaction;

    console.log('[LOCALFORAGE] DB version change', event.oldVersion, event.newVersion);

    if (db.objectStoreNames.contains(DB_STORE_NAME)) {
      // Il clear fa parte della versionchange transaction: nessuna lettura della nuova versione
      // puo' osservare dati della vecchia cache.
      if (event.oldVersion > 0) {
        transaction.objectStore(DB_STORE_NAME).clear();
      }
    } else {
      // Se creiamo noi lo store, LocalForage non dovra' incrementare ancora la versione per farlo.
      db.createObjectStore(DB_STORE_NAME);
    }

    // LocalForage crea questo store di supporto sui DB nuovi. Creandolo nella stessa transazione
    // manteniamo lo schema che si aspetta senza costringerlo a un ulteriore upgrade.
    if (!db.objectStoreNames.contains(LOCAL_FORAGE_BLOB_STORE_NAME)) {
      db.createObjectStore(LOCAL_FORAGE_BLOB_STORE_NAME);
    }

    OBSOLETE_DB_STORE_NAMES.forEach((storeName) => {
      if (storeName !== DB_STORE_NAME && db.objectStoreNames.contains(storeName)) {
        db.deleteObjectStore(storeName);
      }
    });

    clearStorageInfoKeys();

    if (event.oldVersion > 0) {
      // Un cambio di schema invalida anche la sessione locale. Lo snapshot senza token genera lo
      // storage event che fa ricaricare le altre tab e la nuova epoch ne blocca le vecchie scritture.
      invalidatePersistedSession();
    }
  };

  openRequest.onerror = () => {
    // Il gate non deve lasciare l'app bloccata per sempre: LocalForage tentera' comunque la propria
    // apertura e il timeout di idratazione resta l'ultima barriera di sicurezza.
    console.error(`[LOCALFORAGE] apertura DB versione ${DB_VERSION} fallita`, openRequest.error);
    resolve();
  };

  openRequest.onblocked = () => {
    console.warn(`[LOCALFORAGE] upgrade DB alla versione ${DB_VERSION} in attesa delle altre tab`);
  };
});
